export const FREE_FORECAST_DAYS = 7;
export const EXTENDED_FORECAST_DAYS = 15;
export const MIN_DAYS_TO_SPLIT_EXTENDED_OUTLOOK = 10;
export const EXTENDED_FORECAST_CTA_DAY = 'extended-cta';

export const isExtendedForecastCtaDay = (
  value: string | null | undefined,
): boolean => value === EXTENDED_FORECAST_CTA_DAY;

export const splitForecastDaysForOutlook = <T>(
  days: T[],
): {
  nearTermDays: T[];
  extendedDays: T[];
} => {
  if (days.length < MIN_DAYS_TO_SPLIT_EXTENDED_OUTLOOK) {
    return { nearTermDays: days, extendedDays: [] };
  }

  return {
    nearTermDays: days.slice(0, FREE_FORECAST_DAYS),
    extendedDays: days.slice(FREE_FORECAST_DAYS),
  };
};
